
<template>
  <div :class="['mask',needMask?'mask--bg':'']">
    <div class="toast-bg">
      <p class="text">{{showText}}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultTime: 3000
    };
  },
  props: {
    showText: {
      type: String,
      required: true
    },
    needMask: {
      type: Boolean,
      required: false,
      default: false
    },
    waitTime: {
      type: Number,
      required: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.toastCallBack();
    }, this.waitTime || this.defaultTime);
  },
  methods: {
    toastCallBack() {
      this.$emit("toastCallBack");
    }
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 101;
}
.mask--bg {
  background: rgba(0, 0, 0, 0.5);
  pointer-events: auto;
}
.toast-bg {
  background: rgba(0, 0, 0, 0.6);
  border-radius: 10px;
  height: 68px;
}
.text {
  font-size: 24px;
  color: #ffffff;
  line-height: 68px;
  padding: 0 30px;
  img {
    margin-top: -9px;
    margin-right: 4px;
    width: 47px;
    height: 47px;
  }
  i {
    font-size: 37px;
    line-height: 57px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/basic/toast.vue